import BillingsOrderTaxiRailyAddResponse from "../../../../../api/raily/billings/order/taxi-raily/add/billings-order-taxi-raily-add.response";
import BillingsOrderTaxiRailyAdd from "./billings-order-taxi-raily-add";

const create = (
  response: BillingsOrderTaxiRailyAddResponse,
): BillingsOrderTaxiRailyAdd => {
  return {
    id: response.data.id,
  };
};

const billingsOrderTaxiRailyAddFactory = {
  create,
};

export default billingsOrderTaxiRailyAddFactory;
